import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const OPTIONS = [
  { value: 'light', label: 'Light', Icon: Sun },
  { value: 'dark', label: 'Dark', Icon: Moon },
  { value: 'system', label: 'System', Icon: Monitor },
];

export default function ThemeToggle() {
  const { preference, setPreference } = useTheme();

  const onKeyDown = (e) => {
    const idx = OPTIONS.findIndex((o) => o.value === preference);
    let next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = OPTIONS[(idx + 1) % OPTIONS.length];
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = OPTIONS[(idx - 1 + OPTIONS.length) % OPTIONS.length];
    if (!next) return;
    e.preventDefault();
    setPreference(next.value);
    e.currentTarget.querySelector(`[data-value="${next.value}"]`)?.focus();
  };

  return (
    <div className="theme-toggle" role="radiogroup" aria-label="Appearance" onKeyDown={onKeyDown}>
      {OPTIONS.map(({ value, label, Icon }) => {
        const checked = preference === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={checked}
            aria-label={`${label} appearance`}
            title={`Appearance: ${label}`}
            data-value={value}
            tabIndex={checked ? 0 : -1}
            className={`theme-toggle-option${checked ? ' is-active' : ''}`}
            onClick={() => setPreference(value)}
          >
            <Icon size={15} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
